export const SyncDataImportMode = {
    Sync: "Sync",
    Manual: "Manual",
  };

export const OpenStatusType={
  OPEN:1,
  ARCHIVE:2
}